
import React from 'react';
import '../../css/loader.css'

function writer() {

    return (
        <div>
            <div className="loader-overlay flex items-center justify-center fixed top-0 left-0 w-full h-full bg-opacity-50 z-50">
                <div className="typewriter">
                    <div className="slide"><i></i></div>
                    <div className="paper"></div>
                    <div className="keyboard"></div>
                </div>
            </div>
        </div>
    );
}

export default writer;
